module.exports = __webpack_public_path__ + "static/media/ok-icon.f352d422.svg";